export interface TeamMember {
    id: string;
    name: string;
    role: string;
    image: string;
    bioShort: string;
    bioLong: string[];
    linkedin?: string;
    instagram?: string;
    email?: string;
}

export const teamMembers: TeamMember[] = [
    {
        id: "rishal-razack",
        name: "Rishal Razack",
        role: "Founder",
        image: "/assets/images/team/Rishal Razack.png",
        bioShort: "Building a wider NUEVA ecosystem across marketing, education, and production.",
        bioLong: [
            "When I started NUEVA Media Solutions, I wanted to build something bigger than a digital marketing agency. I wanted to create a space where innovation, education, and creativity could come together to drive real digital growth.",
            "Today, NUEVA is built on three pillars:",
            "NUEVA Media Solutions, focused on data-driven digital marketing and measurable growth.",
            "NUEVA Institution, dedicated to helping the next generation of digital professionals learn through practical, hands-on education.",
            "NUEVA Production, focused on creating powerful visual content that tells a brand’s story in an authentic way.",
            "At the heart of everything we do is the same goal: to help businesses and individuals connect, communicate, and grow in a digital-first world.",
        ],
    },
    {
        id: "shabana-sherin",
        name: "Shabana Sherin",
        role: "CEO",
        image: "/assets/images/team/Shabana Sherin.png",
        bioShort: "CEO",
        bioLong: ["CEO"],
    },
    {
        id: "ali-rashad",
        name: "Ali Rashad",
        role: "",
        image: "/assets/images/team/Ali Rashad.png",
        bioShort: "",
        bioLong: [],
    },
    {
        id: "ali-najeeh",
        name: "Ali Najeeh",
        role: "",
        image: "/assets/images/team/Ali Najeeh.png",
        bioShort: "",
        bioLong: [],
    },
    {
        id: "ali-talvar",
        name: "Ali Talvar",
        role: "",
        image: "/assets/images/team/Ali Talvar.png",
        bioShort: "",
        bioLong: [],
    },
    {
        id: "mishab",
        name: "Mishab",
        role: "Senior Designer",
        image: "/assets/images/team/Mishab.png",
        bioShort: "Senior Designer",
        bioLong: ["Senior Designer"],
    },
    {
        id: "rijash",
        name: "Rijash",
        role: "Marketing Head",
        image: "/assets/images/team/Rijash.png",
        bioShort: "Marketing Head",
        bioLong: ["Marketing Head"],
    },
    {
        id: "zidan",
        name: "Zidan",
        role: "Video Editor",
        image: "/assets/images/team/Zidan.png",
        bioShort: "Video Editor",
        bioLong: ["Video Editor"],
    },
    {
        id: "fida-sherin",
        name: "Fida Sherin",
        role: "Client Co-ordinator",
        image: "/assets/images/team/Fida Sherin.png",
        bioShort: "Client Co-ordinator",
        bioLong: ["Client Co-ordinator"],
    },
    {
        id: "abhijit",
        name: "Abhijit",
        role: "SEO Specialist",
        image: "/assets/images/team/Abhijith.png",
        bioShort: "SEO Specialist",
        bioLong: ["SEO Specialist"],
    },
    {
        id: "shahil",
        name: "Shahil",
        role: "Graphic Designer",
        image: "/assets/images/team/Shahil.png",
        bioShort: "Graphic Designer",
        bioLong: ["Graphic Designer"],
    },
];
